export default __webpack_public_path__ + "static/media/play_youtube.b055e7dc.png";